<template>
  <q-separator :vertical="vertical" :inset="inset" :spaced="spaced" />
</template>

<script>
/**
 * Using quasar Badge.
 * https://quasar.dev/vue-components/badge
 *
 * color: {string} - primary, secondary, accent, dark, success, danger, info, warning
 * align: {string} - top, middle, bottom
 * outline: {boolean}
 */

export default {
  name: 'Separator',
  props: {
    vertical: { type: Boolean, default: false },
    inset: { type: Boolean, default: false },
    spaced: { type: [Boolean, String], default: false },
  },
};
</script>
